import { CreateGroupFormData, CreateGroupModalComponent } from './CreateGroupModal.types';
import { Box, Button, Flexbox, Icon, Modal, TextField, Typography } from '@hiiretail/synergy-ui';
import { ErrorBox } from '../../../../common/components/ErrorBox/ErrorBox';
import { Controller } from 'react-hook-form';
import { useGroupForm } from '../../hooks/useGroupForm';

export const CreateGroupModal: CreateGroupModalComponent = ({
  onClose,
  isOpen,
  createGroup,
  isCreating,
  error,
}) => {
  const { control, handleSubmit, formState } = useGroupForm();

  const onFormSubmit = (formData: CreateGroupFormData) => {
    if (!formData.id?.length) {
      delete formData.id;
    }
    createGroup(formData);
  };

  return (
    <Modal
      data-testid="create-group-modal"
      title="Create Group"
      onClose={onClose}
      open={isOpen}
      footer={
        <Flexbox container justifyContent="flex-end">
          <Button
            type="submit"
            onClick={handleSubmit(onFormSubmit)}
            disabled={
              (formState?.errors && !!Object.entries(formState?.errors).length) ||
              Object.keys(formState?.dirtyFields).length < 2 ||
              isCreating
            }
          >
            {isCreating ? 'Creating ...' : 'Create'}
          </Button>
        </Flexbox>
      }
    >
      <ErrorBox error={error} />

      <Flexbox container gutter={4} alignItems="flex-start">
        <Flexbox item>
          <Icon.Info size="lg" color={() => '#6E33A9'} />
        </Flexbox>
        <Flexbox item container>
          <Typography variant="body2">
            A Hii Retail Group represents a named collection containing one or more User identities.
            <br />
            Group members inherit all permissions defined in the group.
          </Typography>
        </Flexbox>
      </Flexbox>

      <form>
        <Box mb={2} pt={4}>
          <Controller
            name="name"
            control={control}
            render={({ field: { ref, value, onChange } }) => (
              <TextField
                tabIndex={0}
                fullWidth
                required
                label="Name"
                name="name"
                // @ts-ignore
                hint={
                  <span>
                    Unique name of the group
                    <br />
                    Can not be longer than 20 characters
                  </span>
                }
                type="text"
                ref={ref}
                value={value}
                onChange={onChange}
                error={formState.errors?.name?.message}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Controller
            name="description"
            control={control}
            render={({ field: { ref, value, onChange } }) => (
              <TextField
                tabIndex={0}
                fullWidth
                required
                label="Description"
                name="description"
                type="text"
                ref={ref}
                // @ts-ignore
                hint={
                  <span>
                    Explains what the group enables users to do.
                    <br />
                    Ie: "Can manage deliveries"
                    <br />
                    Can not be longer than 20 characters
                  </span>
                }
                value={value}
                onChange={onChange}
                error={formState.errors?.description?.message}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Controller
            name="id"
            control={control}
            render={({ field: { ref, value, onChange } }) => (
              <TextField
                tabIndex={0}
                fullWidth
                label="ID"
                name="id"
                type="text"
                ref={ref}
                // @ts-ignore
                hint={
                  <span>
                    Custom ID of the group
                    <br />
                    ID will be autogenerated if you leave this field empty
                    <br />
                    Can not be longer than 256 characters
                  </span>
                }
                value={value}
                onChange={onChange}
                error={formState.errors?.description?.message}
              />
            )}
          />
        </Box>
      </form>
    </Modal>
  );
};
